<template>
  <div class="flt-dropdown-wrap" ref="wrapRef">
    <button
      type="button"
      class="flt-dropdown-btn"
      :class="{ open, selected: modelValue.length > 0 }"
      :disabled="!options.length"
      @click.stop="open = !open"
    >
      <span>{{ modelValue.length ? `${modelValue.length} selecionado${modelValue.length > 1 ? 's' : ''}` : placeholder }}</span>
      <svg class="flt-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </button>

    <transition name="dropdown-slide">
      <div v-if="open && options.length" class="flt-panel">
        <div class="flt-panel-head">
          <button type="button" class="flt-head-btn" @click="selectAll">Todos</button>
          <span class="flt-head-count">{{ options.length }}</span>
          <button type="button" class="flt-head-btn danger" @click="clear">Limpar</button>
        </div>
        <div class="flt-panel-list">
          <label
            v-for="o in options"
            :key="o.id"
            class="flt-item"
            :class="{ checked: isSelected(o.id) }"
            @click.prevent="toggle(o.id)"
          >
            <span class="flt-checkbox" :class="{ checked: isSelected(o.id) }">
              <svg v-if="isSelected(o.id)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </span>
            <span class="flt-item-name">{{ o.name }}</span>
            <span v-if="o.count != null" class="flt-item-count">{{ o.count }}</span>
          </label>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const props = defineProps<{
  options: Array<{ id: number | string; name: string; count?: number }>
  modelValue: Array<number | string>
  placeholder: string
}>()
const emit = defineEmits<{ 'update:modelValue': [value: Array<number | string>] }>()

const open    = ref(false)
const wrapRef = ref<HTMLElement | null>(null)

function isSelected(id: number | string) { return props.modelValue.includes(id) }

function toggle(id: number | string) {
  const next = isSelected(id) ? props.modelValue.filter(v => v !== id) : [...props.modelValue, id]
  emit('update:modelValue', next)
}

function selectAll() { emit('update:modelValue', props.options.map(o => o.id)) }
function clear()     { emit('update:modelValue', []) }

function onDocClick(e: MouseEvent) {
  if (wrapRef.value && !wrapRef.value.contains(e.target as Node)) open.value = false
}
onMounted(() => document.addEventListener('click', onDocClick))
onUnmounted(() => document.removeEventListener('click', onDocClick))
</script>
